<script setup lang="ts">
import { provide, ref, type Ref } from 'vue'
import type { ContainerType } from '@/models/ContainerType'
import type { Room } from '@/models/Room'

const containerType: Ref<ContainerType | null> = ref(null)
const containerCodes: Ref<string[]> = ref([])
const room: Ref<Room | null> = ref(null)

provide('containerType', containerType)
provide('containerCodes', containerCodes)
provide('room', room)
</script>

<template>
  <RouterView />
</template>
